import { faqData } from '@/mocks/comics';

export default function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于YY漫画的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0">Q</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}